import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { AppConfig } from '../../config';

@Injectable({
  providedIn: 'root',
})
export class DigitalnaPlocaService {
  headers = new Headers();

  constructor(private _http: HttpClient) {}

  dohvatiObavijesti(a: any) {
    return this._http.post(AppConfig.ipAddress + 'dp_obavijesti', a)
      .pipe(map((res: any) => res));
  }

  dodajObavijest(a: any) {
    return this._http.post(AppConfig.ipAddress + 'dp_dodaj_obavijest', a)
      .pipe(map((res: any) => res));
  }

  urediObavijest(a: any) {
    return this._http.post(AppConfig.ipAddress + 'dp_uredi_obavijest', a)
      .pipe(map((res: any) => res));
  }

  obrisiObavijest(a: any) {
    return this._http.post(AppConfig.ipAddress + 'dp_obrisi_obavijest', a)
      .pipe(map((res: any) => res));
  }

  dohvatiDokumente(a: any) {
    return this._http.post(AppConfig.ipAddress + 'dp_dokumenti', a)
      .pipe(map((res: any) => res));
  }

  dodajDokument(a: any) {
    return this._http.post(AppConfig.ipAddress + 'dp_dodaj_dokument', a)
      .pipe(map((res: any) => res));
  }

  obrisiDokument(a: any) {
    return this._http.post(AppConfig.ipAddress + 'dp_obrisi_dokument', a)
      .pipe(map((res: any) => res));
  }

}